import React from 'react';
import NoneForm from './None';
import WebsiteForm from './Website';
import OnlineDatabaseForm from './OnlineDatabase';
import { TabHeaders } from '../constants';
export function getTabList(activeTabIndex) {
  return [{
    header: TabHeaders.None,
    panel: activeTabIndex === 0 ? /*#__PURE__*/React.createElement(NoneForm, null) : /*#__PURE__*/React.createElement(React.Fragment, null)
  }, {
    header: TabHeaders.Online,
    panel: activeTabIndex === 1 ? /*#__PURE__*/React.createElement(WebsiteForm, null) : /*#__PURE__*/React.createElement(React.Fragment, null)
  }, {
    header: TabHeaders.OnlineDatabase,
    panel: activeTabIndex === 2 ? /*#__PURE__*/React.createElement(OnlineDatabaseForm, null) : /*#__PURE__*/React.createElement(React.Fragment, null)
  }];
}